import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IComponentController } from "angular";
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';

interface IPageDo0027 extends IComponentController {
    formulaireRgl: IFormulaire;
    rlcMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Do0027Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    MenuItemForage: IMenuItemForageClass,
    Menu: IMenuClass,
    rr0003Route: IRoute,
    rr0020Route: IRoute,
    do0026Route: IRoute,
    sp0004Route: IRoute
) {
    const vm: IPageDo0027 = this;

    const forageDosEmp = [
        new MenuItemForage(
            'BTN_FORAGE_DOSEMP',
            rr0003Route.NAME,
            (rowData: any) => ({
                id: rowData.trncleint
            }),
            {
                icon: 'exit_to_app'
            }
        )
    ];

    const forageComp = [
        new MenuItemForage(
            'BTN_FORAGE_COMP',
            rr0020Route.NAME,
            (rowData: any) => ({
                idecleintref: rowData.idecleintref,
                demcleint : rowData.demcleint
            }),
            {
                icon: 'exit_to_app'
            }
        )
    ];

    const forageDispRap = [
        new MenuItemForage(
            'BTN_FORAGE_DISPRAP',
            do0026Route.NAME,
            (rowData: any) => ({
                id: rowData.rddcleint
            }),
            {
                icon: 'exit_to_app',
                hidden: (rowData: any) => !(rowData.rddcleint)
            }
        )
    ];

    const forageEval = [
        new MenuItemForage(
            'BTN_FORAGE_EVAL',
            sp0004Route.NAME,
            (rowData: any) => ({
                id: rowData.rddcleint
            }),
            {
                icon: 'exit_to_app',
                hidden: (rowData: any) => !(rowData.rddcleint)
            }
        )
    ];
    vm.valeursEcran = ecranDetails.valeurs;
    const criteresSuggeres = new Formulaire([
        new FormulaireItem('rglcod', {
            largeur: 33,
            default: vm.valeursEcran.rglcod,
            readonly: true
        }),
        new FormulaireItem('rgldscabr', {
            largeur: 33,
            default: vm.valeursEcran.rgldscabr,
            readonly: true
        }),
        new FormulaireItemSautDeLigne(),
        new FormulaireItem('rlrdat', {
            largeur: 33,
            default: vm.valeursEcran.rlrdat,
            readonly: true
        }),
        new FormulaireItem('rlrdatcalanc', {
            largeur: 33,
            default: vm.valeursEcran.rlrdatcalanc,
            readonly: true
        }),
        new FormulaireItem('datdebemp', {
            largeur: 33,
            default: vm.valeursEcran.datdebemp
        }),
        new FormulaireItemSautDeLigne(),
        new FormulaireItemSautDeLigne(),
        new FormulaireItem('grecleint', { largeur: 33 }),
        new FormulaireItem('comcleint', { largeur: 33 }),
        new FormulaireItem('litcleint', { largeur: 33 }),
        new FormulaireItemSautDeLigne(),
        new FormulaireItem('vaccleint', { largeur: 33 }),
        new FormulaireItem('grtcleint', { largeur: 33 })
    ], { largeurDefaut: 30 });

    // Liste de rappel
    vm.rlcMultiOccurrenceOptions = {
         fonctions: {
            rechercheCollapsable: false
        },
        criteresSuggeres: criteresSuggeres,
        colonnesVisibles: [
            { nom: 'eplnomprn', largeur: 200, menu: forageDosEmp },
            { nom: 'flgcom', largeur: 110, menu: forageComp },
            { nom: 'eplnummat', largeur: 120 },
            { nom: 'flgdsp', largeur: 70 },
            { nom: 'flgpar', largeur: 70, menu: forageDispRap },
            { nom: 'flgmsg', largeur: 70 },
            { nom: 'hortot', largeur: 120 },
            { nom: 'flgeva', largeur: 70, menu: forageEval },
            { nom: 'rlcanc', largeur: 120 },
            { nom: 'lemcod', largeur: 120 },
            { nom: 'lemdsc', largeur: 250 },
            { nom: 'tel1', largeur: 120 },
            { nom: 'tel2', largeur: 120 },
            { nom: 'unodscfmt', largeur: 120 },
            { nom: 'aftdsc', largeur: 200 },
            { nom: 'aftmul', largeur: 100 },
            { nom: 'aftdatdeb', largeur: 120 },
            { nom: 'aftdatfin', largeur: 120 },
            { nom: 'tafflgprb', largeur: 90 },
            { nom: 'dercansou', largeur: 120 },
            { nom: 'dalnumdoc', largeur: 120 },
            { nom: 'daltyp', largeur: 120 },
            { nom: 'dalflgmul', largeur: 90 },
            { nom: 'grgcod', largeur: 120 },
            { nom: 'grgdscabr', largeur: 300 },
            { nom: 'temdscabr', largeur: 300 },
            { nom: 'comdsc', largeur: 500 },
            { nom: 'rlcflgman', largeur: 100 }
        ],
        colonnesCachees: ['demcleint']
    };
}
